<template>
  <div class="pag-default-box pag-body-text pag-legend-container">
    <button
              class="filter-toggle legend-collapse-button"
              :class="legendBoxVisible ? null : 'collapsed'"
              :aria-expanded="legendBoxVisible ? 'true' : 'false'"
              aria-controls="container-collapse-legend"
              @click="legendBoxVisible = !legendBoxVisible"
            >
              <font-awesome-icon
                class="filter-toggle-chevron-icon"
                :icon="
                  legendBoxVisible
                    ? ['fas', 'chevron-down']
                    : ['fas', 'chevron-right']
                "
              />
              <span
                class="filter-toggle-label pag-text-color"
                v-html="
                  $te('VMX.filter_box_legend')
                    ? $t('VMX.filter_box_legend')
                    : 'Legend'
                "
              />
              <font-awesome-icon
                class="filter-toggle-slider-icon"
                :icon="['fas', 'circle-info']"
              />
            </button>
  <b-collapse
            id="container-collapse-legend"
            v-model="legendBoxVisible"
            class="container-collapse-legend"
            accordion="my-accordion-legend-box"
            role="tabpanel"
          >
          
    <div class="legend-container"  v-if="initialized">
      <div
        v-if="displaySymbols && showLegendSymbols"
        class="symbol-container"
      >
        <span
          class="filter-toggle-label symbol-child"
          v-html="
            $t('VMX.legend_headline')
          "
        />
        <span
          class="symbol-child"
          v-if="showSaveFavourites"
        >
          <font-awesome-icon
            class="symbol-child-icon"
            :icon="['fas', 'star']"
          />
          <span
            v-html="
              $t('VMX.legend_toggle_favourites')
            "
          />
        </span>
        <span
          class="symbol-child"
          v-if="showSaveCalendar"
        >
          <font-awesome-icon
            class="symbol-child-icon"
            :icon="['fas', 'calendar']"
          />
          <span
            v-html="$t('VMX.my_programme_save_calender')"
          />
        </span>
        <span
          class="symbol-child"
          v-if="showViews"
        >
          <font-awesome-icon
            class="symbol-child-icon"
            :icon="['fas', 'eye']"
          />
          <span
            v-html="$t('VMX.legend_view_count')"
          />
        </span>
        <span
          class="symbol-child"
          v-if="showCoffeeBreak"
        >
          <font-awesome-icon
            class="symbol-child-icon"
            :icon="['fas', 'mug-saucer']"
          />
          <span
            v-html="$t('VMX.legend_coffee_break')"
          />
        </span>
        <span
          class="symbol-child"
          v-if="showOnDemandSymbol"
        >
          <font-awesome-icon
            class="symbol-child-icon"
            :icon="['fas', 'circle-play']"
          />
          <span
            v-html="$t('VMX.legend_on-demand')"
          />
        </span>
        <span
          class="symbol-child"
          v-if="showLiveSymbol"
        >
          <font-awesome-icon
            class="symbol-child-icon"
            :icon="['fas', 'wifi']"
          />
          <span
            v-html="$t('VMX.legend_live')"
          />
        </span>
      </div>
      <div v-if="showMetadata && metaData && metaData[filterName]" class="metadata-container">
        <div class="metadata">
          <template v-if="filterName === 'PresentationTypes'">
          <span
            v-for="(item, idx) in metaData[filterName]"
            :key="idx"
          >
            <span
              v-if="item.WebcastEnabled && item.TypeName"
              class="metadata_tags pag-default-btn"
              @click="openFilter(item.GroupName, filterName)"
            >
              {{ item.TypeName }}
            </span>
          </span>
          </template>
          <template v-if="filterName === 'SessionGroups'">
          <span
            v-for="(item, idx) in filteredSessionGroups"
            :key="idx"
            :style="`color: ${useSessionTypesTextColor ? SessionGroupsTextColor : item.GroupColor }; background-color: ${SessionGroupsBackgroundColor ? SessionGroupsBackgroundColor : '#fff'}; border: 1px solid ${item.GroupColor ? item.GroupColor : 'var(--pag-primary)' }`"
            :class="{
              'active': activeGroup === item.GroupName,
              'metadata_tags-groups': true,
              'pag-default-btn': true
            }"
            @click="setActiveGroup(item.GroupName); openFilter(item.GroupName, filterName)"
          >
            {{ item.GroupName }}
          </span>
        </template>
          <template v-if="filterName === 'SessionTypes'">
          <span
            v-for="(item, idx) in filteredSessionTypes"
            :key="idx"
          >
          <span
            :style="`background-color: ${SessionTypesBackgroundColor ? SessionTypesBackgroundColor : '#fff'};
              color: ${useSessionTypesTextColor ? SessionTypesTextColor : item.TypeColor};
              font-weight: 700; border: 1px solid ${item.TypeColor ? item.TypeColor : 'var(--pag-primary)'}`
            "
            :class="{
              'active': activeItem === item.TypeName,
              'metadata_tags-groups': true, 
              'pag-default-btn': true
            }"
            @click="setActiveItem(item.TypeName); openFilter(item.TypeName, filterName)"
          >
            {{ item.TypeName }}
          </span>

          </span>
          </template>
        </div>
        <button class="filter-toggle-label pag-default-btn" v-html="$t('VMX.reset_filter_label')" @click="resetFilter()" />
      </div>
    </div>
    <div class="legend-container fake-legend" v-else-if="!initialized"> 
      <span>
        Legend Container
      </span>
    </div>
  </b-collapse>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EventBus from '~/states/event-bus'
import utils from '../utilities'

export default {
  async created() {
    await this.loadMetaData()
        this.initialized = true
  },
  async mounted() {
    this.legendBoxVisible = this.legendBoxUnfolded
  },
  data() {
    return {
      initialized: false,
      legendBoxVisible: false,
      activeGroup: null,
      activeItem: null,
    }
  },
  methods: {
    ...mapActions({
      loadMetaData: 'pagSessions/loadMetaData',
    }),
    setActiveItem(typeName) {
    this.activeItem = typeName; 
  },
  setActiveGroup(groupName) {
    this.activeGroup = groupName; 
  },
    openFilter(name, metadata) {
    if (this.$route.name === 'PagSearchPage') {
      EventBus.$emit('metaDataFilter', { name, metadata })
    } else {
      if (metadata === 'SessionTypes') this.$router.push(utils.getRouteWithDefaultParams('PagSearchPage', {}, { viewType: 'list', types: name }))
      if (metadata === 'SessionGroups') this.$router.push(utils.getRouteWithDefaultParams('PagSearchPage', {}, { viewType: 'list', groups: name }))
    }
  },
  resetFilter() {
    EventBus.$emit('resetFilter')
  },
  },
  computed: {
    ...mapGetters({
      metaData: 'pagSessions/sessionMetaData',
      configForKey: 'config/configForKey',
    }),
    isPag() {
      const layer = localStorage.getItem('layer');
      return layer === 'Manage' || layer === 'Standalone';
    },
    showLiveSymbol() {
    if (this.hideLiveSymbolInStandalone) {
      return !this.isPag;
    }
    return this.showLive;
    },
    showOnDemandSymbol() {
      if (this.hideOnDemandSymbolInStandalone) {
        return !this.isPag;
      }
      return this.showOnDemand;
    },
    filteredSessionTypes() {
      if (this.metaData && this.metaData[this.filterName] && this.filterName === 'SessionTypes' && this.SessionTypeFilter) {
        return this.metaData[this.filterName]
          .filter(item => !this.SessionTypeFilter.includes(item.TypeId))
          .sort((a, b) => (a.TypeName || '').localeCompare(b.TypeName || ''));
      } else {
        return this.metaData[this.filterName].sort((a, b) => (a.TypeName || '').localeCompare(b.TypeName || ''));
      }
    },
    filteredSessionGroups() {
  if (this.metaData && this.metaData[this.filterName] && this.filterName === 'SessionGroups' && this.SessionGroupFilter) {
      return this.metaData[this.filterName]
        .filter(item => !this.SessionGroupFilter.includes(item.GroupId))
        .sort((a, b) => (a.GroupName || '').localeCompare(b.GroupName || ''));
   } else {
      return this.metaData[this.filterName].sort((a, b) => (a.GroupName || '').localeCompare(b.GroupName || ''));
    }
}
  },
  props: {
    legendBoxUnfolded: {
      type: Boolean,
      default: true,
    },
    showSaveCalendar: {
      type: Boolean,
      default: true,
    }, 
    showSaveFavourites: {
      type: Boolean,
      default: true,
    },
    showViews: {
      type: Boolean,
      default: true,
    },
    showLive: {
      type: Boolean,
      default: true,
    },
    showOnDemand: {
      type: Boolean,
      default: true,
    },
    showCoffeeBreak: {
      type: Boolean,
      default: true,
    }, 
    displaySymbols: {
      type: Boolean,
      default: true,
    }, 
    filterName: {
      type: String,
      default: 'SessionTypes',
    }, 
    SessionGroupsBackgroundColor: {
      type: String,
      default: '#fff',
    },
    useSessionGroupsTextColor: {
      type: Boolean,
      default: false,
    },
    showLegendSymbols: {
      type: Boolean,
      default: true,
    },
    showMetadata: {
      type: Boolean,
      default: true,
    },
    hideLiveSymbolInStandalone: {
      type: Boolean,
      default: false,
    },
    hideOnDemandSymbolInStandalone: {
      type: Boolean,
      default: false,
    },
    SessionGroupsTextColor: {
      type: String,
      default: '#000',
    }, 
    SessionTypesBackgroundColor: {
      type: String,
      default: '#fff',
    },
    useSessionTypesTextColor: {
      type: Boolean,
      default: false,
    },
    SessionTypesTextColor: {
      type: String,
      default: '#000',
    },
    SessionTypeFilter: {
      type: Array,
      default() {
        return null
      },
    },
    SessionGroupFilter: {
      type: Array,
      default() {
        return null
      },
    }
  },
}
</script>

<style lang="scss" scoped>

.legend-container {
  display: flex;
  flex-direction: column;
  gap: .5rem;

  .symbol-container {
    display: flex;
    flex-wrap: wrap;

    gap: .5rem;
    .symbol-child {
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      gap: .25rem;
      span {
        white-space: nowrap;
        font-size: .875rem;
      }
    }
  }
}
.metadata {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}
.metadata_tags-groups, .metadata_tags {
  color: var(--pag-text-color-inverted);
  display: inline-block;
  font-size: 0.875rem;
  line-height: 1.5;
  padding: var(--pag-button-padding);
  text-align: center;
  vertical-align: middle;
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}

.metadata-container {
  display: flex;
  gap: .5rem;
  justify-content: space-between;
  flex-wrap: wrap;
}
.pag-legend-container {
  padding: var(--pag-box-padding);
}
.legend-collapse-button {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-weight: 700;
  text-align: left;
  display: flex;
  gap: 0.5rem;
  align-items: center;
  outline: none;
}

  .fake-legend {
    margin: 0 1.5rem;
  background: #f2eeee;
  color: #f2eeee;
  border-radius: .25rem;
  animation: left-slide-in 5s ease-in 0s infinite normal forwards;
}
.fake-legend span {
  visibility: hidden;
}
@keyframes left-slide-in {
	0%,
	50%,
	100% {
		opacity: 1;
	}

	25%,
	75% {
		opacity: 0;
	}
}
</style>